var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSwiperItem',{attrs:{"item":_vm.item,"related-mode":""}})}
var staticRenderFns = []

export { render, staticRenderFns }